import { createRouter, createMemoryHistory, type RouteRecordRaw } from "vue-router";
import LoginView from "@/features/auth/views/LoginView.vue";
import ProfileView from "@/features/profile/views/ProfileView.vue";
import SignaturesView from "@/features/signature/views/SignaturesView.vue";

const routes: RouteRecordRaw[] = [
  { path: "/", redirect: "/login" },
  { path: "/login", name: "login", component: LoginView },
  { path: "/profile", name: "profile", component: ProfileView },
  { path: "/signatures", name: "signatures", component: SignaturesView },
];

const router = createRouter({
  history: createMemoryHistory(),
  routes,
});

export default router;
